import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between pt-2" }
const _hoisted_3 = { class: "flex flex-1 items-center gap-x-6 mb-4" }
const _hoisted_4 = { class: "w-280" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "px-2" }
const _hoisted_9 = { class: "flex-1 flex justify-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { id: "excel-export" }, null, -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Export", -1)
const _hoisted_14 = { class: "px-5" }
const _hoisted_15 = { class: "text-textColor font-bold text-md mb-" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_DriverSelect = _resolveComponent("DriverSelect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_vue_excel_xlsx = _resolveComponent("vue-excel-xlsx")!
  const _component_DynamicTable = _resolveComponent("DynamicTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, {
          title: `cacheSettlements.title_${_ctx.type}`
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DriverSelect, {
            modelValue: _ctx.selectedDriver,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDriver) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: _ctx.$t('placeholders.adminUsername'),
            class: "h-42 px-3 appearance-none bg-transparent",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adminUsername) = $event))
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.adminUsername]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Datepicker, {
            range: "",
            "enable-time-picker": true,
            modelValue: _ctx.dateRange,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateRange) = $event)),
            format: 'dd.MM.yyyy',
            class: "w-full",
            placeholder: _ctx.$t('reports.darkStoreOrderPeakHours.dateRangePlaceholder')
          }, null, 8, ["modelValue", "format", "placeholder"])
        ]),
        _createElementVNode("button", {
          class: "primary h-10 px-2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFilter && _ctx.onFilter(...args)))
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Search')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_vue_excel_xlsx, {
            data: _ctx.exportData,
            columns: _ctx.exportFields,
            "file-name": "Cash_Settlements",
            "file-type": 'xlsx',
            "sheet-name": 'sheetname'
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createElementVNode("button", {
                disabled: _ctx.exportLoading,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTableToExcel($event))),
                class: "flex items-center primary px-4 py-2"
              }, [
                (!_ctx.exportLoading)
                  ? (_openBlock(), _createBlock(_component_BaseIcon, {
                      key: 0,
                      name: "file-white"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.exportLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                  : _createCommentVNode("", true),
                _hoisted_13
              ], 8, _hoisted_11)
            ]),
            _: 1
          }, 8, ["data", "columns"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_DynamicTable, {
        tableData: _ctx.records,
        loading: _ctx.loading,
        tableFields: _ctx.tableFields,
        scrollable: true,
        buttons: { edit: true, delete: true, export: false },
        clickable: true,
        onNavigateToLink: _ctx.gotoDetail
      }, null, 8, ["tableData", "loading", "tableFields", "onNavigateToLink"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.pagination && _ctx.pagination.totalItems)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            current: _ctx.current,
            total: _ctx.pagination.totalItems,
            "page-range": 2,
            basicPagination: false,
            "per-page": _ctx.pagination.pageSize,
            onPageChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.current = $event)),
            "text-before-input": "Go to page"
          }, null, 8, ["current", "total", "per-page"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.confirmObject)
      ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
          key: 0,
          header: _ctx.confirmObject.title,
          hasIcon: false,
          cancelText: _ctx.$t('buttons.no'),
          confirmText: _ctx.$t('buttons.yes'),
          onConfirm: _ctx.confirmObject?.handler,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmObject = null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.confirmObject.message), 1)
          ]),
          _: 1
        }, 8, ["header", "cancelText", "confirmText", "onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}